import { render, staticRenderFns } from "./InformacoesResidenciais.vue?vue&type=template&id=025cefe8&"
import script from "./InformacoesResidenciais.vue?vue&type=script&lang=js&"
export * from "./InformacoesResidenciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports